export default __webpack_public_path__ + "media/DIAMOND PACKAGE.99ecaaa10e022f609e174d48d54cfffd.mp4";